import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import ConveyanceMasterKeys from 'src/constants/locale/key/ConveyanceMaster'

const ConveyanceMasterTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.CONVEYANCE_MASTER
    ])
    let conveyanceMaster = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.TITLE)
    let conveyanceID = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CONVEYANCE_I_D)
    let carrierCode = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CARRIER_CODE)
    let conveyanceNo = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CONVEYANCE_NO)
    let conveyanceType = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CONVEYANCE_TYPE)
    let email = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.EMAIL)
    let aceId = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.ACE_ID)
    let status = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.STATUS)
    let vinNo = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.VIN_NO)
    let transponderNo = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.TRANSPONDER_NO)
    let licensePlates = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.LicensePlates.TITLE)
    let licensePlateNo = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.LicensePlates.LICENSE_PLATE_NO)
    let countryofRegistration = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.LicensePlates.COUNTRYOF_REGISTRATION)
    let state = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.LicensePlates.STATE)
    let backToConveyanceMasterList = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.BACK_TO_CONVEYANCE_MASTER_LIST)
    let addLicensePlate = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.ADD_LICENSE_PLATE)
    let addNew = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.ADD_NEW)
    let licensePlate = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.LICENSE_PLATE)
    let submissionDate = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMISSION_DATE)
    let responseDate = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.RESPONSE_DATE)
    let submitSentRecords = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMIT_SENT_RECORDS)
    let submitSuccessMessage = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMIT_SUCCESS_MESSAGE)
    let submitErrorMessage = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMIT_ERROR_MESSAGE)
    let editButton = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.EDIT_BUTTON)
    let editSentRecords = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.EDIT_SENT_RECORDS)
    let deleteButton = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.DELETE_BUTTON)
    let deleteSentRecords = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.DELETE_SENT_RECORDS)
    let submitButton = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMIT_BUTTON)
    let cancelButton = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CANCEL_BUTTON)
    let submitDialogTitle = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.SUBMIT_DIALOG_TITLE)
    let msgFuncType = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.MSG_FUNC_TYPE)
    let msgFuncAdd = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.MSG_FUNC_ADD)
    let msgFuncDeactivate = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.MSG_FUNC_DEACTIVATE)
    let msgFuncModify = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.MSG_FUNC_MODIFY)
    let createConveyanceMaster = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CREATE_CONVEYANCE_MASTER)
    let conveyanceDeletedSuccessMsg = translate(Namespace.CONVEYANCE_MASTER, ConveyanceMasterKeys.CONVEYANCE_DELETED_SUCCESS_MSG)
    return {
      conveyanceMaster,
      conveyanceID,
      carrierCode,
      conveyanceNo,
      conveyanceType,
      email,
      aceId,
      status,
      vinNo,
      transponderNo,
      licensePlates,
      licensePlateNo,
      countryofRegistration,
      state,
      backToConveyanceMasterList,
      addLicensePlate,
      addNew,
      licensePlate,
      submissionDate,
      responseDate,
      submitSentRecords,
      submitSuccessMessage,
      submitErrorMessage,
      editButton,
      editSentRecords,
      deleteButton,
      deleteSentRecords,
      submitButton,
      cancelButton,
      submitDialogTitle,
      msgFuncType,
      msgFuncAdd,
      msgFuncDeactivate,
      msgFuncModify,
      createConveyanceMaster,
      conveyanceDeletedSuccessMsg
    }
}

export default ConveyanceMasterTranslationText